import React from "react";
import { Modal, Button } from "react-bootstrap";
import DeleteRedIcon from "../icons/DeleteRedIcon";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { clearStorage } from "../services/storage.service";
import { AxiosError } from "axios";
import { DeleteModalType } from "../constants/utlis";
import { delteUserProfile } from "../services/user.service";
import { all_routes } from "../feature-module/router/all_routes";
import { updateAuthorizationHeader } from "../services/http.service";
import { useDispatch, useSelector } from "react-redux";
import { archiveUser, deleteInvitedUser } from "../core/data/redux/manageUser/_manageUserAction";
import ArchiveModalIcon from "../icons/ArchiveModalIcon";
import { archiveProperty } from "../core/data/redux/property/_propertyAction";
import { archiveLogHour, deleteLogHour, deleteLogHourReceipt } from "../core/data/redux/logHour/_logHourAction";
import { deleteMileage, deleteMileageReceipt } from "../core/data/redux/mileage/_mileageAction";
import { archiveActivity } from "../core/data/redux/activity/_activityAction";
import { archiveNonRealLogHour, deleteNonRealLogHourDocument } from "../core/data/redux/nonRealLogHour/_nonRealLogHourAction";
import { cancelSubscription, deleteCard, setDefaultCard } from "../core/data/redux/pricing/_pricingAction";
import { setHasSubscription, setPlanPermission, setToken } from "../core/data/redux/user/userSlice";

interface DeleteModalProps {
  show: boolean;
  onHide: () => void;
  type: DeleteModalType;
  uuid?: string | null;
  data?: any
  onSuccess?: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ show, onHide, type, uuid, data, onSuccess }) => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const routes: any = all_routes;
  const userDetail = useSelector((state: any) => state.user?.userDetail);
  const has_subscription = useSelector((state: any) => state.user?.has_subscription);
  const userInfo = { ...userDetail, has_subscription };

  const handleConfirmAction = async () => {
    try {
      switch (type) {
        case "deleteAccount":
          const result = await delteUserProfile();
          toast.success(result?.data?.message);
          clearStorage();
          dispatch(setToken(null));
          dispatch(setHasSubscription(false));
          dispatch(setPlanPermission(null));
          navigate(routes.login);
          onHide();
          updateAuthorizationHeader();
          break;

        case "archiveUser":
          if (!uuid) {
            toast.error("No user selected for archiving");
            return;
          }
          await dispatch(archiveUser({ uuid, archieve: true }));
          onHide();
          break;

        case "deleteInvitedUser":
          if (!uuid) {
            toast.error("No user selected for archiving");
            return;
          }
          await dispatch(deleteInvitedUser({ uuid }));
          onHide();
          break;

        case "archiveProperty":
          if (!uuid) {
            toast.error("No user selected for archiving");
            return;
          }
          await dispatch(archiveProperty({ uuid, archieve: true }));
          onHide();
          break;

        case "archiveLogHour":
          if (!uuid) {
            toast.error("No user selected for archiving");
            return;
          }
          await dispatch(archiveLogHour({ uuid, archieve: true }));
          onHide();
          break;

        case "deleteMileageReceipt":
          if (!uuid) {
            toast.error("No item selected for archiving");
            return;
          }
          console.log('data === ', data);

          await dispatch(deleteMileageReceipt({ uuid, mileageId: data?.uuid }));
          onSuccess?.();
          onHide();
          break;

        case "deleteLogHourReceipt":
          if (!uuid) {
            toast.error("No item selected for archiving");
            return;
          }

          await dispatch(deleteLogHourReceipt({ uuid, logHoureId: data }));
          onSuccess?.();
          onHide();
          break;

        case "deleteMileage":
          if (!uuid) {
            toast.error("No user selected for archiving");
            return;
          }
          await dispatch(deleteMileage({ uuid }));
          onHide();
          break;

        case "spouceDeleteLogHour":
          if (!uuid) {
            toast.error("No data selected for archiving");
            return;
          }
          await dispatch(deleteLogHour({ uuid }));
          onHide();
          break;

        case "archiveActivity":
          if (!uuid) {
            toast.error("No activity selected for archiving");
            return;
          }
          await dispatch(archiveActivity({ uuid, archieve: true }));
          onHide();
          break;

        case "archiveNonRealLogHour":
          if (!uuid) {
            toast.error("No data selected for archiving");
            return;
          }
          await dispatch(archiveNonRealLogHour({ uuid, archieve: true }));
          onHide();
          break;

        case "deleteNonRealLogHourDocument":
          if (!uuid) {
            toast.error("No item selected for archiving");
            return;
          }

          await dispatch(deleteNonRealLogHourDocument({ uuid, logHoureId: data }));
          onSuccess?.();
          onHide();
          break;

        case "activeUser":
          if (!uuid) {
            toast.error("No user selected for updating");
            return;
          }
          await dispatch(archiveUser({ uuid, archieve: false }));
          onHide();
          break;

        case "inactiveUser":
          if (!uuid) {
            toast.error("No user selected for updating");
            return;
          }
          await dispatch(archiveUser({ uuid, archieve: true }));
          onHide();
          break;

        case "cancelSubscription":
          await dispatch(cancelSubscription());
          onSuccess?.();

          onHide();
          break;

        case "deleteCard":
          if (!uuid) {
            toast.error("No card selected for deleting");
            return;
          }
          await dispatch(deleteCard({ payment_method_id: uuid }));
          onHide();
          break;

        case "setDefaultCard":
          if (!uuid) {
            toast.error("No card selected for deleting");
            return;
          }
          await dispatch(setDefaultCard({ card_id: uuid }));
          onHide();
          break;

        default:
          break;
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.error);
      }
      console.log(error);
    }
  };

  const getModalContent = () => {
    switch (type) {
      case "deleteAccount": {
        const deleteAccountMessage =
          userInfo?.has_subscription && userInfo?.user_subscription?.status === "active"
            ? `Your account will be deactivated immediately. Your data will be retained for 30 days in accordance with our Privacy Policy and will be permanently deleted after this period. Please cancel your subscription from your Apple In-App Purchase settings before deleting your account.`
            : `Deleting your account will immediately cancel your active subscription and deactivate your account. Your information will be retained for 30 days as described in our Privacy Policy and will be permanently deleted after that period.`;
        return {
          icon: <DeleteRedIcon />,
          title: "Delete Account",
          message: deleteAccountMessage,
          confirmText: "Delete",
          cancelText: "Cancel",
        };
      }

      case "archiveUser":
        return {
          icon: <ArchiveModalIcon />,
          title: "Archive User",
          message: "This action will permanently remove this user.",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "deleteInvitedUser":
        return {
          icon: <DeleteRedIcon />,
          title: "Delete User",
          message: "This action will permanently remove this user.",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "archiveProperty":
        return {
          icon: <ArchiveModalIcon />,
          title: "Archive Property",
          message: "Are you sure you want to archive this Property?",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "archiveLogHour":
        return {
          icon: <ArchiveModalIcon />,
          title: "Archive log hour",
          message: "Are you sure you want to archive this log hour?",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "deleteMileageReceipt":
        return {
          icon: <DeleteRedIcon />,
          title: "Delete Mileage Receipt",
          message: "This action will permanently remove this file.",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "deleteLogHourReceipt":
        return {
          icon: <DeleteRedIcon />,
          title: "Delete Log Hour Receipt",
          message: "This action will permanently remove this file.",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "deleteMileage":
        return {
          icon: <DeleteRedIcon />,
          title: "Delete Mileage",
          message: "Are you sure you want to delete this Mileage entry?",
          confirmText: "Delete",
          cancelText: "Cancel",
        };

      case "spouceDeleteLogHour":
        return {
          icon: <DeleteRedIcon />,
          title: "Delete Log Hours",
          message: "Are you sure you want to delete this Log Hours?",
          confirmText: "Delete",
          cancelText: "Cancel",
        };

      case "archiveActivity":
        return {
          icon: <ArchiveModalIcon />,
          title: "Archive Activity",
          message: "Are you sure you want to archive this Activity?",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "archiveNonRealLogHour":
        return {
          icon: <ArchiveModalIcon />,
          title: "Archive Log Hour",
          message: "Are you sure you want to archive this Log Hour?",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "deleteNonRealLogHourDocument":
        return {
          icon: <DeleteRedIcon />,
          title: "Delete Log Hour Document",
          message: "This action will permanently remove this file.",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "activeUser":
        return {
          icon: <ArchiveModalIcon />,
          title: "Active User",
          message: "This action will active user account.",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "inactiveUser":
        return {
          icon: <ArchiveModalIcon />,
          title: "Inactive User",
          message: "This action will inactive user account.",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "cancelSubscription":
        return {
          icon: <DeleteRedIcon />,
          title: "Cancel Subscription",
          message: "Are you sure you want to cancel your subscription?",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      case "deleteCard":
        return {
          icon: <DeleteRedIcon />,
          title: "Delete Card",
          message: "Are you sure you want to delete this Card entry?",
          confirmText: "Delete",
          cancelText: "Cancel",
        };

      case "setDefaultCard":
        return {
          icon: <DeleteRedIcon />,
          title: "Set Default Card",
          message: "Are you sure you want to set this Card as default?",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };

      default:
        return {
          icon: <DeleteRedIcon />,
          title: "Confirmation",
          message: "Are you sure?",
          confirmText: "Yes",
          cancelText: "No",
        };
    }
  };

  const { icon, title, message, confirmText, cancelText } = getModalContent();

  return (
    <Modal
      className="deleteModal"
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="text-center">
        <div className="mx-auto py-4">{icon}</div>
        <h4>{title}</h4>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center gap-3">
        <Button className="btnWrp cancelBtn" onClick={onHide}>
          {cancelText}
        </Button>
        <Button className="btnWrp" onClick={handleConfirmAction}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;

function delesetDefaultCardteCard(arg0: { uuid: string; }): any {
  throw new Error("Function not implemented.");
}
